module.exports = __webpack_public_path__ + "static/media/graySettingsIcon.7efab113.svg";